module.exports = __webpack_public_path__ + "img/pg4-article-text1.8faabd99.png";